// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FactorsBoard_wrapper__Kl5zz"};